<template>
  <div>
    <el-tabs class="el-tabs__customize" v-if="supplierInfoShow[source]">
      <el-tab-pane label="供应商信息">
        <el-form :model="form" label-width="210px">
          <el-row>
            <el-col :span="12">
              <el-form-item label="供应商名称：">
                <span>{{ form.supName }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="供应商编码：">
                <span>{{ form.supCode }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="联系人：">
                <span>{{ form.contractName }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="传真：">
                <span>{{ form.fax }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="联系电话：">
                <span>{{ form.mobile }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="邮箱：">
                <span>{{ form.email }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12" v-if="pType !== '50' && pType !== '53'">
              <el-form-item
                :label="
                  '投标总金额(' +
                    form.moneyUnit +
                    ')' +
                    (isLeasingZone ? '含税：' : '：')
                "
              >
                <span>{{ new BigNumber(form.priceAmount).toFormat(2) }}</span>
              </el-form-item>
            </el-col>
            <el-col
              :span="12"
              v-if="pType !== '50' && pType !== '53' && isLeasingZone"
            >
              <el-form-item
                :label="'投标总金额(' + form.moneyUnit + ')不含税：'"
              >
                <span>{{
                  new BigNumber(priceAmountTaxExcluded).toFormat(2)
                }}</span>
              </el-form-item>
            </el-col>
            <el-col
              :span="12"
              v-if="pType !== '50' && pType !== '53' && isLeasingZone"
            >
              <el-form-item :label="'税额(' + form.moneyUnit + ')：'">
                <span>{{ new BigNumber(priceTaxAmount).toFormat(2) }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="投标时间：">
                <span>{{ form.priceTime }}</span>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-tab-pane>
    </el-tabs>
    <el-tabs
      class="el-tabs__customize"
      v-if="pType !== '50' && pType !== '53' && offerInfoShow[source]"
    >
      <el-tab-pane label="报价信息">
        <div class="center" v-if="isLeasingZone">
          <span class="chlidName">
            <!-- 投标总金额(元) -->
            {{ "投标总金额合计（" + unit + "）含税" }}：<span
              style="color:#FF142F "
              >{{ new BigNumber(form.priceAmount).toFormat(2) }}</span
            >
          </span>
          <span class="chlidName">
            <!-- 投标总金额(元) -->
            {{ "投标总金额合计（" + unit + "）不含税" }}：<span
              style="color:#FF142F "
              >{{ new BigNumber(priceAmountTaxExcluded).toFormat(2) }}</span
            >
          </span>
          <span class="chlidName">
            <!-- 税额(元) -->
            {{ "税额合计（" + unit + "）" }}：<span style="color:#FF142F ">{{
              new BigNumber(priceTaxAmount).toFormat(2)
            }}</span>
          </span>
        </div>
        <el-table
          :data="quoteTableData"
          border
          :span-method="spanMethod"
          :summary-method="getSummariesMethod"
          class="totalTable"
          :show-summary="!isLeasingZone"
        >
          <el-table-column
            v-for="(item, index) in columns"
            :key="index"
            :min-width="columns.width"
            :show-overflow-tooltip="true"
            v-bind="item"
          >
            <template v-if="item.child">
              <el-table-column
                v-for="(child, childIndex) in item.child"
                :key="childIndex"
                :show-overflow-tooltip="true"
                v-bind="child"
              ></el-table-column>
            </template>
            <template slot-scope="scope">
              <span>{{ scope.row[item.prop] }}</span
              ><span
                v-if="
                  item.prop == 'packName' && Number(scope.row.packStatus) !== 1
                "
                style="color:red"
                >（已流标）</span
              >
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
    <el-tabs class="el-tabs__customize">
      <el-tab-pane label="附件">
        <el-table :data="fileTableData" border>
          <el-table-column
            type="index"
            width="50"
            label="序号"
          ></el-table-column>
          <el-table-column
            property="fileName"
            label="附件名称"
            show-overflow-tooltip
            width="180"
          ></el-table-column>
          <el-table-column
            property="fileSize"
            label="附件大小"
            show-overflow-tooltip
            width="180"
          >
            <template slot-scope="{ row }">
              <span>{{ row.fileSize }}K</span>
            </template>
          </el-table-column>
          <el-table-column
            property="fileSumm"
            label="附件说明"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column label="操作" width="100">
            <template slot-scope="{ row }">
              <el-button type="text" @click="download(row)">下载</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import {
  qrySupBidPriceDetailApi,
  qrySupBidPriceDetailKJApi,
  qrySupBidPriceInfoApi,
  qryFileinfoListApi
} from "@/app/sourcingFlow/api/expertEvaluation.js";
import { addUrlPerFix } from "@/basa/utils";
// import { NumFormat } from "@/basa/filters";
import BigNumber from "bignumber.js";
import { processTableData } from "@/app/sourcingFlow/utils/processTableData";
export default {
  name: "supplierBidDetails",
  props: {
    templateType: {
      type: String,
      default: ""
    },
    supQuoteId: {
      type: String,
      default: ""
    },
    supCode: {
      type: String,
      default: ""
    },
    purchaseType: {
      type: String,
      default: ""
    },
    source: {
      type: String,
      default: "default"
    }
  },
  data() {
    return {
      unit: sessionStorage.getItem("moneyTypeName"),
      offerInfoShow: Object.freeze({
        technicalBusinessScore: false,
        bidOpenSituation: false,
        default: true
      }),
      supplierInfoShow: Object.freeze({
        technicalBusinessScore: true,
        bidOpenSituation: false,
        default: true
      }),
      BigNumber: BigNumber,
      form: {},
      quoteTableData: [],
      fileTableData: [],
      packFlag: true,
      pType: "",
      columns: [],
      columns2: Object.freeze([
        {
          prop: "packName",
          label: "包件名称",
          width: 150
        },
        {
          prop: "index_1",
          label: "序号",
          width: 50
        },
        {
          prop: "matCode",
          label: "物料编码",
          width: 200
        },
        {
          prop: "matName",
          label: "物料名称",
          width: 200
        },
        {
          prop: "convMeasureUnitName",
          label: "单位",
          width: 120
        },
        {
          prop: "convPurchaseNum",
          label: "采购数量",
          width: 100
        },
        {
          prop: "priceItem",
          label: "报价明细",
          child: [
            {
              prop: "priceItem",
              label: "费用名称",
              width: 140
            },
            {
              prop: "convPriceAmount",
              label: "费用报价",
              width: 140
            }
          ]
        },
        {
          prop: "exchangeRangeLabel",
          label: "税率",
          width: 90
        },
        {
          prop: "comUnitPrice",
          label:
            "综合单价（" + sessionStorage.getItem("moneyTypeName") + "）含税",
          width: 240
        },
        {
          prop: "totalPrice",
          label: "金额（" + sessionStorage.getItem("moneyTypeName") + "）含税",
          width: 240
        },
        {
          prop: "totalPriceTaxExcluded",
          label:
            "金额（" + sessionStorage.getItem("moneyTypeName") + "）不含税",
          width: 240
        }
      ]),
      priceAmountTaxExcluded: 0,
      priceTaxAmount: 0,
      isLeasingZone: false
    };
  },

  mounted() {
    this.isLeasingZone =
      JSON.parse(sessionStorage.getItem("expertSourceData")).baseAppId ==
        "107407" ||
      JSON.parse(sessionStorage.getItem("expertSourceData")).baseAppId ==
        "119934";
    if (this.isLeasingZone) {
      const newColumns = [
        ...this.columns2.slice(0, 9),
        {
          prop: "comUnitPriceTaxExcluded",
          label:
            "综合单价（" + sessionStorage.getItem("moneyTypeName") + "）不含税",
          width: 240
        },
        ...this.columns2.slice(9, 11),
        {
          prop: "totalPriceTaxAmount",
          label: "税额（" + sessionStorage.getItem("moneyTypeName") + "）",
          width: 240
        }
      ];
      this.columns2 = Object.freeze(newColumns);
    }
    if (this.templateType) {
      let index = this.columns2.findIndex(i => i.prop == "priceItem");
      if (index != -1) {
        this.columns2[index].child[1] = {
          label: "费用报价",
          prop: "convPriceAmountTaxExcluded",
          align: "left"
        };
      }
    }
    this.getData();
    this.pType = JSON.parse(
      sessionStorage.getItem("expertSourceData")
    ).purchaseType;
  },
  methods: {
    getshuie(totalPrice, totalPriceTaxExcluded) {
      let totalPriceTaxAmountStr = window.$computeUtil.getMinusTwo(
        String(totalPrice).replace(/,/g, "") || 0,
        String(totalPriceTaxExcluded).replace(/,/g, "") || 0
      );
      return totalPriceTaxAmountStr;
    },
    getData() {
      qrySupBidPriceInfoApi({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId,
        supQuoteId: this.supQuoteId,
        supCode: this.supCode
      }).then(res => {
        this.form = res.data.data;
      });
      let crud =
        this.templateType == 1 || this.templateType == 2
          ? qrySupBidPriceDetailKJApi
          : qrySupBidPriceDetailApi;
      crud({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId,
        supQuoteId: this.supQuoteId
      }).then(res => {
        if (res.data.data && res.data.data.length > 0) {
          let data = [];
          this.priceAmountTaxExcluded = 0;
          this.priceTaxAmount = 0;
          let oneSpan = 0;
          // 判断没有包件名称的情况
          if (res.data.data.length === 1 && res.data.data[0].packId === 0) {
            this.packFlag = false;
            this.columns = this.columns2.filter(n => n.prop !== "packName");
          } else {
            this.columns = this.columns2.map(n => n);
          }

          res.data.data.forEach((item, index) => {
            item.sscSupBidPriceMatBOS = processTableData(
              item.sscSupBidPriceMatBOS
            );
            let id = 0;
            if (index > 0) {
              res.data.data[index - 1].sscSupBidPriceMatBOS.forEach(cItem => {
                oneSpan += cItem.sscSupPriceItemBOS.length;
              });
            }
            let twoSpan = 0;
            let oneRowSpan = 0;
            item.sscSupBidPriceMatBOS.forEach(a => {
              a.sscSupPriceItemBOS.forEach(b => {
                oneRowSpan++;
              });
            });
            item.sscSupBidPriceMatBOS.forEach((aItem, aIndex) => {
              id++;
              if (aIndex > 0) {
                twoSpan +=
                  item.sscSupBidPriceMatBOS[aIndex - 1].sscSupPriceItemBOS
                    .length;
              }
              aItem.totalPriceTaxExcluded = aItem.totalPriceTaxExcludedStr
                ? new BigNumber(aItem.totalPriceTaxExcludedStr).toFormat(2)
                : "--";
              aItem.totalPriceTaxAmount = this.getshuie(
                aItem.totalPriceStr,
                aItem.totalPriceTaxExcludedStr
              );
              aItem.sscSupPriceItemBOS.forEach((bItem, bIndex) => {
                let object = {
                  id: id,
                  index_1: aItem.index_1,
                  packId: item.packId,
                  packName: item.packName,
                  packStatus: item.packStatus,
                  schemeMatId: aItem.schemeMatId,
                  matCode: aItem.matCode,
                  matName: aItem.matName,
                  matDesc: aItem.matDesc,
                  convPurchaseNum: aItem.convPurchaseNum,
                  convMeasureUnitName: aItem.convMeasureUnitName
                    ? aItem.convMeasureUnitName
                    : aItem.measureUnitName,
                  comUnitPrice: aItem.comUnitPriceStr
                    ? new BigNumber(aItem.comUnitPriceStr).toFormat(2)
                    : "--",
                  comUnitPriceTaxExcluded: aItem.comUnitPriceTaxExcludedStr
                    ? new BigNumber(aItem.comUnitPriceTaxExcludedStr).toFormat(
                        2
                      )
                    : "--",
                  totalPrice: aItem.totalPriceStr
                    ? new BigNumber(aItem.totalPriceStr).toFormat(2)
                    : "--",
                  totalPriceTaxExcluded: aItem.totalPriceTaxExcludedStr
                    ? new BigNumber(aItem.totalPriceTaxExcludedStr).toFormat(2)
                    : "--",
                  totalPriceTaxAmount: this.getshuie(
                    aItem.totalPriceStr,
                    aItem.totalPriceTaxExcludedStr
                  ),
                  bidPriceItemId: bItem.bidPriceItemId,
                  convPriceAmount: bItem.convPriceAmountStr
                    ? new BigNumber(bItem.convPriceAmountStr).toFormat(2)
                    : "--",
                  priceItem: bItem.priceItem,
                  oneSpan: oneSpan,
                  twoSpan: twoSpan,
                  oneRowSpan: oneRowSpan,
                  twoRowSpan: aItem.sscSupPriceItemBOS.length,
                  exchangeRangeLabel: aItem.exchangeRangeLabel,
                  convPriceAmountTaxExcludedStr:
                    bItem.convPriceAmountTaxExcludedStr,
                  convPriceAmountTaxExcluded: new BigNumber(
                    bItem.convPriceAmountTaxExcluded
                  ).toFormat(2)
                };
                data.push(object);
              });
              this.priceAmountTaxExcluded += this.formatThousandToNumber(
                aItem.totalPriceTaxExcluded
              );
              this.priceTaxAmount += this.formatThousandToNumber(
                aItem.totalPriceTaxAmount
              );
            });
          });
          this.quoteTableData = data;
          console.log(this.quoteTableData);
        }
      });
      qryFileinfoListApi({
        parentBillId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId,
        billId: this.supQuoteId,
        billType: "0603",
        uploadPhase: "0603"
      }).then(res => {
        this.fileTableData = res.data.data;
      });
    },
    formatThousandToNumber(str) {
      // 先判断是否为有效字符串，空值返回0或按需处理
      if (!str || typeof str !== "string") return 0;

      // 移除所有逗号，再转换为数字
      const numStr = str.replace(/,/g, "");
      const number = Number(numStr);

      // 校验转换结果，非数字返回0（避免NaN）
      return isNaN(number) ? 0 : number;
    },
    spanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex < 1 && this.packFlag) {
        if ((rowIndex - row.oneSpan) % row.oneRowSpan === 0) {
          return {
            rowspan: row.oneRowSpan,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      } else if (columnIndex < 1 && this.packFlag == false) {
        if ((rowIndex - row.twoSpan) % row.twoRowSpan === 0) {
          return {
            rowspan: row.twoRowSpan,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      } else if (
        this.packFlag &&
        (columnIndex === 1 ||
          columnIndex === 2 ||
          columnIndex === 3 ||
          columnIndex === 4 ||
          columnIndex === 5 ||
          columnIndex === 8 ||
          columnIndex === 9 ||
          columnIndex === 10 ||
          columnIndex === 11 ||
          columnIndex === 12 ||
          columnIndex === 13)
      ) {
        if ((rowIndex - row.twoSpan) % row.twoRowSpan === 0) {
          return {
            rowspan: row.twoRowSpan,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      } else if (
        this.packFlag === false &&
        (columnIndex === 1 ||
          columnIndex === 2 ||
          columnIndex === 3 ||
          columnIndex === 4 ||
          columnIndex === 7 ||
          columnIndex === 8 ||
          columnIndex === 9 ||
          columnIndex === 10 ||
          columnIndex === 11 ||
          columnIndex === 12)
      ) {
        if ((rowIndex - row.twoSpan) % row.twoRowSpan === 0) {
          return {
            rowspan: row.twoRowSpan,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },
    getSummariesMethod(param) {
      let sums = [
        "投标总金额合计(含税)：",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        new BigNumber(this.form.priceAmount).toFormat(2)
      ];
      if (this.packFlag == false) {
        sums = [
          "",
          "投标总金额合计(含税)：",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          new BigNumber(this.form.priceAmount).toFormat(2)
        ];
      }
      return sums;
    },
    download(row) {
      let openUrl = document.createElement("a");
      openUrl.style.display = "none";
      openUrl.href = `${addUrlPerFix(
        process.env.VUE_APP_BASE_URL
      )}/apis/bid/oss/downloadByUploadId?fileUrl=${
        row.fileUrl
      }&fileName=${encodeURIComponent(row.fileName)}`;
      openUrl.setAttribute("download", row.fileName);
      document.body.appendChild(openUrl);
      openUrl.click();
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/ .el-form .el-form-item {
  margin-bottom: 20px !important;
}
/deep/ .el-tabs__customize {
  .el-tabs__header {
    margin-bottom: 20px !important;
    padding-top: 20px !important;
  }
}
/deep/ .el-table--border {
  th:last-of-type.gutter {
    display: table-cell !important;
    width: 0px !important;
  }
}
/deep/.el-table__body-wrapper .cell {
  width: 100% !important;
}
/deep/.el-table__footer {
  width: 100% !important;
}
/deep/.el-table__footer-wrapper {
  tbody {
    td {
      background: #fff;
      border-right: 0;
      &:nth-last-child(2) {
        border-left: 1px solid #edf2fc !important;
      }
    }
  }
}
.center {
  padding: 10px 10px;
  color: #4a4a4a;
  font-size: 14px;
  .chlidName {
    margin-right: 30px;
  }
}
</style>
